import{b as i,c as s}from"./chunk-WUCJ5FDJ.js";import{e as n,m as t}from"./chunk-HBP5N4FR.js";function R(e,o){Boolean(e)&&e!=null&&setTimeout(()=>{window.location.pathname.includes(e)||(typeof o=="function"?o(e):i(e))},200)}var d=n(()=>{t();s()});export{R as a,d as b};
//# sourceMappingURL=chunk-MP7NBSJV.js.map
